(function (Drupal, $) {
  'use strict';

  function equalHeight () {
    $('.links-processed .link-wrapper-inner').matchHeight({ remove: true }).matchHeight({})
  }

  function linksBlock() {
    if (!$('.job-offer-links-block').hasClass('processed')) {
      const elems = $('.job-offer-links-block').find('.field > .field__item')

      $('.job-offer-links-block').addClass('processed')
      $('.job-offer-links-block').append('<div class="links-processed">')
      $('.job-offer-links-block .links-processed').append(elems)

      $('.job-offer-links-block .links-processed .field__item').wrap('<div class="link-wrapper"><div class="link-wrapper-inner">')

    }
  }

  function setupHeaderMinHeight ($header) {
      const contentHeight = $header.find('.group-text').height()

      $header.css({
        minHeight: contentHeight + 40
      })
    }

  function setupHeader () {
    const headers = $('.group-header .wrapper')

    headers.each(function (headerId, header) {
      const $header = $(header)

      setupHeaderMinHeight($header)
    })
  }

  $(window).off('resize.jobOffer').on('resize.jobOffer', function () {
    setupHeader()
  })

  Drupal.behaviors.jobOffer = {
    attach: function (context, settings) {
      linksBlock()
      equalHeight()
      setupHeader()
    }
  }

})(Drupal, jQuery)
